import {
  PersonalData, PersonalDataRequest,
} from '~/types/PersonalData';

export interface PersonalDataApi {
  /** PHRデータの取得 */
  getPersonalData: () => Promise<PersonalData>

  /** PHRデータの更新（patch） */
  updatePersonalData: (requestBody: PersonalDataRequest) => Promise<PersonalData>
}

export const usePersonalDataApi = (fetch, axios): PersonalDataApi => {
  const getPersonalData = async (): Promise<PersonalData> => {
    const res = await fetch('/phr-data');
    return res.data.phrData;
  };

  const updatePersonalData = async (requestBody: PersonalDataRequest): Promise<PersonalData> => {
    const res = await axios.patch('/phr-data', requestBody);
    return res.data.phrData;
  };

  return {
    getPersonalData,
    updatePersonalData,
  };
};
